export const formatNumber = (value?: number) => {
  const normalizedValue = value || 0
  if (!value) return value

  return new Intl.NumberFormat('pt-BR').format(normalizedValue)
}
